import React from 'react';
import MessageView from './MessageView';
import * as FolderStore from 'store/Folder';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import CreateFolderButton from './CreateFolderButton';

const HomeView = () => {
    const folders = useSelector(FolderStore.selectors.foldersFlattened);

    if (folders.length > 0) {
        // redirect to first folder
        return <Navigate to={`/folder/${folders[0].id}`} replace />
    }

    return (
        <MessageView>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                Welcome to the Product Image Hub!
                <br /><br />
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <CreateFolderButton iconLabelButton />
                </div>
            </div>
        </MessageView>
    );
}

export default HomeView;